import { GoogleAnalytics } from "@next/third-parties/google";
import { canUseGoogleAnalytics, GoogleAnalyticsUser } from "./googleAnalytics";
import { TRACKING_SCRIPT_DELAY_MS, useDelayAfterLoad } from "../utils/useDelayAfterLoad";

type GoogleAnalyticsScriptProps = {
    user: GoogleAnalyticsUser;
    gaId?: string;
};

/**
 * Loads Google Analytics a delay after the page has loaded. Only the first instance on a page loads, the scripts share a fixed id.
 * @param props.user The user the page is tracked for, god mode users are not tracked
 * @param props.gaId The measurement id, defaults to the Authory one
 * @returns The analytics scripts, or nothing in development, without an id, for god mode users or before the delay has passed
 */
export function GoogleAnalyticsScript({ user, gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID }: GoogleAnalyticsScriptProps) {
    const delayElapsed = useDelayAfterLoad(TRACKING_SCRIPT_DELAY_MS);

    if (!canUseGoogleAnalytics(user, gaId) || !delayElapsed) return null;

    return <GoogleAnalytics gaId={gaId} />;
}
